/**
 * Workspaces (tenants) — mock data.
 *
 * The product is multi-tenant: a workspace is the tenant, and a user holds a
 * role *within* a workspace rather than globally. `superadmin` is the platform
 * operator (us) and is deliberately not a workspace role — it comes from
 * `AuthContext.isSuperAdmin`, which reads Supabase `app_metadata`.
 *
 * Nothing here is scoped or enforced yet. It exists so the shell can render the
 * switcher the design calls for; when tenancy lands, replace `MOCK_WORKSPACES`
 * with an API call and keep the shape.
 */

/** A user's role inside one workspace. */
export type WorkspaceRole = 'admin' | 'member';

export interface Workspace {
  id: string;
  name: string;
  /** Two-letter monogram shown in the switcher when there is no logo. */
  initials: string;
  /** Tailwind gradient classes for the monogram tile. */
  accentClass: string;
  /** The signed-in user's role in this workspace. */
  role: WorkspaceRole;
  /** Seats currently occupied — shown in the switcher. */
  memberCount: number;
}

export const MOCK_WORKSPACES: Workspace[] = [
  {
    id: 'ws-marketing',
    name: 'Marketing Team',
    initials: 'MT',
    accentClass: 'from-blue-500 to-indigo-600',
    role: 'admin',
    memberCount: 8,
  },
  {
    id: 'ws-sales',
    name: 'Sales Team',
    initials: 'ST',
    accentClass: 'from-emerald-500 to-teal-600',
    role: 'member',
    memberCount: 5,
  },
  {
    id: 'ws-agency',
    name: 'Agency HQ',
    initials: 'AH',
    accentClass: 'from-amber-500 to-orange-600',
    role: 'admin',
    memberCount: 21,
  },
];

export const DEFAULT_WORKSPACE_ID = MOCK_WORKSPACES[0].id;
